export default {"src":"/_next/static/media/CHECKLIST_ICON.d9e9b68d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};